// "/" lands on the desktop surface while Desktop Mode is on, otherwise on the
// dashboard exactly as before (CR #133). Kept as its own tiny component so the
// route table stays declarative.
import { Navigate } from 'react-router-dom';
import { useDesktopMode } from '@/lib/hooks/useDesktopMode';

export const HomeRedirect = () => {
  const desktopMode = useDesktopMode();
  return <Navigate to={desktopMode ? '/desktop' : '/dashboard'} replace />;
};
